import gtm from '@/utils/gtm';
import { useState } from 'react';
import styles from './index.module.scss';

export default function HoverBtn({ className, text, desc }: any) {
    const [show, setShow] = useState(false);

    function onClickHandle(e: any) {
        setShow(!show);
        e.stopPropagation();
        e.preventDefault();
        gtm.push({
            __btn_id1: `${styles.comp}`,
            __btn_id2: 'close-btn-1',
            __btn_type: 'common',
        });
    }

    return (
        <div
            className={`${styles.comp} GtmModuleData-btn-common`}
            onClick={onClickHandle}
            data-btn-id="close-btn-1"
            // onMouseEnter={() => setShow(true)}
            // onMouseLeave={() => setShow(false)}
        >
            <div className={`hover-btn-container ${className}`}>
                <div className={`close-icon ${show ? 'show' : ''}`}>
                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle data-figma-bg-blur-radius="75" cx="12" cy="12.8398" r="12" fill="white" fillOpacity="0.3" />
                        <path d="M12.998 11.8398H18.001V13.8398H12.998V18.8408H10.998V13.8398H6V11.8398H10.998V6.83984H12.998V11.8398Z" fill="white" />
                        <defs>
                            <clipPath id="bgblur_0_4439_12604_clip_path" transform="translate(75 74.1601)">
                                <circle cx="12" cy="12.8398" r="12" />
                            </clipPath>
                        </defs>
                    </svg>

                    {/* <EFPicture src="https://websiteoss.ecoflow.com/upload/image/1757321764471/icon.png" /> */}
                </div>
                <div className={`content ${show ? 'show' : ''}`}>
                    <span className="btn-text">{text}</span>
                    <span className={`btn-desc ${show ? 'show' : ''}`}>
                        <span>{desc}</span>
                    </span>
                </div>
            </div>
        </div>
    );
}
